import { Stack } from '@sparky';
import { styled } from '@sparky/stitches';

export const StackContainer = styled(Stack, {
  minHeight: '100vh',
});
